import { render, staticRenderFns } from "./POD-10-2023View.vue?vue&type=template&id=52662b76&scoped=true&"
import script from "./POD-10-2023View.vue?vue&type=script&lang=js&"
export * from "./POD-10-2023View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52662b76",
  null
  
)

export default component.exports